import { csrfToken } from '~/modules/legacyRequest.js';

const TRACK_IMPRESSIONS_PATH = '/track_impressions';

function buildRequestBody(payload) {
  return JSON.stringify(payload);
}

export function sendTrackImpressionBatch(payload, options = {}) {
  if (!payload || !Array.isArray(payload.impressions) || payload.impressions.length === 0) {
    return Promise.resolve(false);
  }

  const useBeacon = options.useBeacon === true;
  const body = buildRequestBody(payload);

  if (useBeacon && typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    try {
      const blob = new Blob([body], { type: 'application/json' });
      return Promise.resolve(navigator.sendBeacon(TRACK_IMPRESSIONS_PATH, blob));
    } catch (_error) {
      // Fall through to fetch keepalive.
    }
  }

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  const token = csrfToken();

  if (token) {
    headers['X-CSRF-Token'] = token;
  }

  return fetch(TRACK_IMPRESSIONS_PATH, {
    method: 'POST',
    credentials: 'same-origin',
    keepalive: useBeacon,
    headers: headers,
    body: body
  }).then(function(response) {
    return response.ok;
  }).catch(function() {
    return false;
  });
}
